import assign from 'object-assign';
import { EventEmitter } from 'events';
import { unescapeHTML } from 'underscore.string';

import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'CUSTOMER_SEARCH_CHANGE';
const CUSTOMER_AUDITS_EVENT = 'CUSTOMER_AUDITS_CHANGE';

let searchResults = [];
let customerAudits = [];
const CustomerSearchStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },
  emitAuditChange() {
    this.emit(CUSTOMER_AUDITS_EVENT);
  },
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
  addAuditChangeListener(callback) {
    this.on(CUSTOMER_AUDITS_EVENT, callback);
  },
  removeAuditChangeListener(callback) {
    this.removeListener(CUSTOMER_AUDITS_EVENT, callback);
  },
  clearSearchResults() {
    searchResults = [];
    this.emitChange();
  },
  getSearchResults() {
    return searchResults;
  },
  setSearchResults(r) {
    if (!r) return;

    searchResults = r?.map((item) => {
      const optimized_name =
        item.optimized_name &&
        unescapeHTML(
          item.optimized_name.replace(/(&.+;)/, (v) => v.toLowerCase()),
        );
      const mappedItem = {
        ...item,
        company_name: unescapeHTML(item.company_name || '').trim(),
        account_name: unescapeHTML(item.account_name || '').trim(),
        first_name: unescapeHTML(item.first_name || '').trim(),
        last_name: unescapeHTML(item.last_name || '').trim(),
        optimized_name,
        value: item._id,
        type: item._type,
      };

      if (item._type === 'Shipper') {
        mappedItem.name = mappedItem.company_name;
        const locations = (item.locations || []).map(
          (location) => location.location,
        );
        mappedItem.locations = locations;
      } else if (item._type === 'Vendor') {
        mappedItem.name = mappedItem.company_name;
      } else if (item._type === 'Driver') {
        mappedItem.name =
          `${mappedItem.first_name} ${mappedItem.last_name}`.trim();
        if (item.carrier) {
          mappedItem.carrierData = item.carrier;
          mappedItem.carrier = unescapeHTML(item.carrier.name);
        }
      } else if (item._type === 'Admin') {
        mappedItem.name = `${mappedItem.first_name} ${mappedItem.last_name}`;
      }
      mappedItem.name = unescapeHTML(mappedItem.name);
      return mappedItem;
    });
  },
  getCustomerAudits() {
    return customerAudits;
  },
  setCustomerAudits(data) {
    customerAudits = data.audits;
    CustomerSearchStore.emitAuditChange();
  },
});

CustomerSearchStore.dispatchToken = AdminAppDispatcher.register(
  function (payload) {
    const action = payload.action;
    switch (action.type) {
      case ActionTypes.SEARCH_CUSTOMERS_SUCCESS:
        CustomerSearchStore.setSearchResults(action.customers);
        CustomerSearchStore.emitChange();
        break;
      case ActionTypes.FETCH_CUSTOMER_AUDITS_SUCCESS:
        CustomerSearchStore.setCustomerAudits(action.audits);
        break;
      default:
        break;
    }
  },
);

export default CustomerSearchStore;
